import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxExtendedPdfViewerService, pdfDefaultOptions } from 'ngx-extended-pdf-viewer';
import { AIChatModalService } from 'src/app/core/services/modal-services/ai-chat-modal.service';

@Component({
  selector: 'app-pdf-viewer-modal',
  templateUrl: './pdf-viewer-modal.component.html',
  styleUrls: ['./pdf-viewer-modal.component.scss']
})
export class PdfViewerModalComponent {
  constructor(
    private modalRef: NgbActiveModal,
  ) { pdfDefaultOptions.assetsFolder = 'bleeding-edge'; }
  @Input() public blob: any;
  @Input() public documentName?: string;

  widthPx = 856;
  pdfSrc: string = "";
  showNoDocument: boolean = false;

  ngOnInit(): void {
    if (window.innerWidth < 400) {
      this.widthPx = window.innerWidth * 0.9;
    } else if (window.innerWidth < 992) {
      this.widthPx = 400;
    } else if (window.innerWidth < 1200) {
      this.widthPx = 600;
    }
    var fileURL = URL.createObjectURL(this.blob);
    if (fileURL) {
      this.pdfSrc = fileURL
    } else {
      this.showNoDocument = true;
    }
  }
  close() {
    this.modalRef.close();
  }
}
